import React, { useEffect, useMemo } from 'react';
import VideoElement from './videoElement';
import { useSelector } from 'react-redux';
import { AttendeeName, Avatar } from '../../common';
import { getParticipantBlockStatus, setPresentationTracks, setPresentationViewParticipant } from '../../../utils/functions';
import FrameRateIndicator from './FrameRateIndicator';

function PresentationView({ showActiveWindow }) {
  const presentationParticipant = useSelector(
    state => state.conf.presentationParticipant,
  );
  const currentActiveVideoTracks = useSelector(
    state => state.conf.currentActiveVideoTracks,
  );

  const screenSharedJid = useSelector(state => state.conf.screenSharedJid);
  const refreshVideoView = useSelector(state => state.conf.refreshVideoView);
  const screenDimension = useSelector(state => state.conf.screenDimension);
  const { height, width } = screenDimension;
  const show_fps_in_recording = useSelector(state => state.conf.roomDetail?.show_fps_in_recording);

  useEffect(() => {
    setPresentationViewParticipant(showActiveWindow);
  }, [showActiveWindow, screenSharedJid, refreshVideoView]);

  useEffect(() => {
    setPresentationTracks(true,showActiveWindow);
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [currentActiveVideoTracks]);

  const name = useMemo(() => {
    return presentationParticipant.name
      ? presentationParticipant.name + '&#39;s Presentation'
      : '';
  }, [presentationParticipant]);

  let isBlocked = useMemo(() => {
    return getParticipantBlockStatus(presentationParticipant);
  }, [presentationParticipant]);

  const videoTrack = presentationParticipant?.track;

  return (
    <div className={'videoBlock videoSpeaker'} style={{ width: `${width}px`, height: `${height}px` }}>
      <div className="videoBlockInner">
        {videoTrack ? (
          <>
            <VideoElement track={videoTrack.jitsiTrack} />
            {name && <AttendeeName name={name} />}
            {
              show_fps_in_recording && <FrameRateIndicator participantJid={presentationParticipant?.jid} />
            }
          </>
        ) : isBlocked ? (
          <>
            <Avatar
              participant={presentationParticipant}
              isBlocked={isBlocked}
            />
          </>
        ) : (
          <video className="videoloading" />
        )}
      </div>
    </div>
  );
}

export default PresentationView;
